function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { usePrefetchedSignupAssets } from "client/services/signup/prefetch-signup-service";
import * as Sentry from "@sentry/nextjs";
import { PREFETCH_ALL_ASSETS_COMPLETED, PREFETCH_ASSET_COMPLETED } from "constants/bigbrain-event-types";
import { trackEvent } from "services/bigbrain-service";
import { PREFETCH_TYPES } from "constants/prefetch-constants";
const SignupPrefetchedAssetsLinksComponent = ()=>{
    const allPrefetchedSignupAssets = usePrefetchedSignupAssets();
    let numberOfLinksSuccessfullyPrefetched = 0;
    const dnsPrefetchedDomains = allPrefetchedSignupAssets.filter((asset)=>asset.type === PREFETCH_TYPES.DNS_PREFETCH);
    const preConnectedDomains = allPrefetchedSignupAssets.filter((asset)=>asset.type === PREFETCH_TYPES.PRECONNECT);
    const prefetchedSignupAssets = allPrefetchedSignupAssets.filter((asset)=>asset.type === PREFETCH_TYPES.PREFETCH);
    const totalNumberOfAssetsToBePrefetched = prefetchedSignupAssets === null || prefetchedSignupAssets === void 0 ? void 0 : prefetchedSignupAssets.length;
    const PREFETCHED_LINK_ID = (index)=>`prefetched_link_${index}`;
    const onLinkRendered = ({ href, index })=>{
        try {
            // setTimeout needed to ensure it's not run synchronously, and link elements were already rendered in the DOM
            setTimeout(()=>{
                const linkElement = document.querySelector(`link[id=${PREFETCHED_LINK_ID(index)}]`);
                if (linkElement) {
                    linkElement.onload = function() {
                        trackEvent(PREFETCH_ASSET_COMPLETED, {
                            kind: href,
                            info1: index,
                            info2: numberOfLinksSuccessfullyPrefetched++,
                            info3: totalNumberOfAssetsToBePrefetched
                        });
                        if (numberOfLinksSuccessfullyPrefetched === totalNumberOfAssetsToBePrefetched) {
                            trackEvent(PREFETCH_ALL_ASSETS_COMPLETED, {
                                info3: totalNumberOfAssetsToBePrefetched
                            });
                        }
                    };
                    linkElement.onerror = function() {
                        Sentry.captureMessage(`Prefetch of the following asset failed: ${href}`);
                    };
                } else {
                    Sentry.captureMessage(`Couldn't query link with id: ${PREFETCHED_LINK_ID(index)} and href: ${href}`);
                }
            });
        } catch (e) {
            Sentry.captureException(e);
        }
    };
    return [
        dnsPrefetchedDomains === null || dnsPrefetchedDomains === void 0 ? void 0 : dnsPrefetchedDomains.map((prefetchedDomain, index)=>/*#__PURE__*/ _jsx("link", {
                rel: prefetchedDomain.type,
                href: prefetchedDomain.href
            }, index)),
        preConnectedDomains === null || preConnectedDomains === void 0 ? void 0 : preConnectedDomains.map((preConnectedDomain, index)=>/*#__PURE__*/ _jsx("link", {
                rel: preConnectedDomain.type,
                href: preConnectedDomain.href
            }, index)),
        prefetchedSignupAssets === null || prefetchedSignupAssets === void 0 ? void 0 : prefetchedSignupAssets.map((prefetchedAsset, index)=>/*#__PURE__*/ _jsx("link", {
                id: PREFETCHED_LINK_ID(index),
                rel: prefetchedAsset.type,
                href: prefetchedAsset.href,
                onLoad: onLinkRendered(_object_spread_props(_object_spread({}, prefetchedAsset), {
                    index
                }))
            }, index))
    ];
};
export default SignupPrefetchedAssetsLinksComponent;
